import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import UserFooter from './components/footer/UserFooter';
import BannerMain from './components/banner/BannerMain';
import DetailWrapp from './components/detailWrapp/DetailWrapp';
import WorkWrapp from './components/workWrapp/WorkWrapp';
import Compensation from './components/compensation/Compensation';
// import Timeline from './components/timeLine/Timeline';
import NewsWrapp from './components/news/NewsWrapp';
import Dashboard from './components/dashboard/Dashboard';
import Additionalinfo from './components/additionalinfo/Additionalinfo';
import Evidence from './components/evidence/Evidence';
import OurService from './components/ourService/OurService';
import LoginPage from './components/loginPage/LoginPage';
import RegisterPage from './components/registerPage/RegisterPage';
import AllegationWrapp from './components/allegation/AllegationWrapp';
import EligibleWrapp from './components/eligibleWrapp/EligibleWrapp';
import ClaimWrapp from './components/claimWrapp/ClaimWrapp';
import JoinWrapp from './components/joinWrapp/JoinWrapp';
import JoinWrapp2 from './components/joinWrapp2/JoinWrapp2';
import { END_URL, IMG_URL } from "../src/config.js";
import CaseUpdate from './components/caseUpdates/CaseUpdate';
import FaqWrapp from './components/faqs/FaqWrapp';
import ResetPassword from './components/ResetPassword/ResetPassword';
import NotificationWrapp from './components/notification/NotificationWrapp';
import ResourceWrapp from './components/resources/ResourceWrapp';
import DashboardNew from './components/dashBoardNew/DashboardNew';
import Privacy from './components/privacy/privacy';
import Terms from './components/terms/terms';
import Contact from './components/contact/contact';
import AboutPage from './components/aboutPage/AboutPage';
import ErrorPage from './components/ErrorPage/ErrorPage';
import CaseSummary from './components/caseSummary/CaseSummary.jsx';
import Settings from './components/settings/settings.jsx';
import Submission from './components/submissions/Submissions.jsx';
// import Timelines from './components/timeline/timeline.jsx';
import CaseDetails from './components/case-details/CaseDetails.jsx';

function AppContent() {
  const [home, setHome] = useState(null);
  const location = useLocation();
  const isLoggedIn = sessionStorage.getItem('authToken');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${END_URL}home`);
        setHome(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const banners = home?.data?.banners || [];
  const reviews = home?.data?.reviews || [];

  const footerRoutes = ['/', '/aboutPage'];
  const shouldShowFooter = !isLoggedIn || footerRoutes.includes(location.pathname);

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <BannerMain data={banners[0]} />
              {/* {banners.length > 0 ? <CaseDetails data={banners[0]} /> : <p>Loading...</p>} */}
              <CaseDetails data={banners[0]} products={home?.data?.products} />
              <ClaimWrapp data={banners[0]} />
              <JoinWrapp data={banners[0]} reviews={reviews} />
              {banners.length > 0 ? <NewsWrapp data={banners[0]} /> : <p></p>}
              {banners.length > 0 ? <JoinWrapp2 data={banners[0]} /> : <p></p>}
            </>
          }
        />

        {/* Protected Routes */}
        <Route path="/dashboard" element={<ProtectedRoute element={<DashboardNew />} />} />
        <Route path="/users/:step?" element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path="/additionalinfo" element={<ProtectedRoute element={<Additionalinfo />} />} />
        <Route path="/evidence" element={<ProtectedRoute element={<Evidence />} />} />
        <Route path="/contact" element={<Contact  isLoggedIn={isLoggedIn} />} />

        {/* Public Routes */}
        <Route path="/loginPage" element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
        <Route path="/registerPage" element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <RegisterPage />} />

        <Route path="/caseupdate" element={<CaseUpdate />} />
        <Route path="/faqwrapp" element={<FaqWrapp />} />
        <Route path="/notifications" element={<NotificationWrapp />} />
        <Route path="/resources" element={<ResourceWrapp />} />
        <Route path="/privacy" element={<Privacy isLoggedIn={isLoggedIn} />} />
        <Route path="/terms" element={<Terms  isLoggedIn={isLoggedIn}  />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/aboutPage" element={<> <Header /> <AboutPage /> </>} />
        <Route path="/Error" element={<ErrorPage />} />
        <Route path="/caseOverview" element={<ProtectedRoute element={<CaseSummary />} />} />
        <Route path="/submission" element={<ProtectedRoute element={<Submission />} />} />
        <Route path="/settings" element={<ProtectedRoute element={<Settings />} />} />

        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>

      {shouldShowFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;